import axios from 'axios';
import {
  MDBAlert,
  MDBBadge,
  MDBBtn,MDBRow,MDBCol,
  MDBCard, MDBCardBody,
  MDBCardTitle,
  MDBCarousel, MDBCarouselItem,
  MDBChipsInput,
  MDBDatepicker,
  MDBIcon,
  MDBInfiniteScroll,
  MDBInput,
  MDBSpinner,
  MDBTabs,
  MDBTabsContent,MDBCardHeader,
  MDBTabsItem,
  MDBTabsLink,
  MDBCardFooter
} from "mdb-react-ui-kit";
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';

import descImage from './forDescriptions.png';
import { MDBOrganizationChart } from 'mdb-react-organization-chart';
import DisplayList from '../utils/DisplayList';
import { GeographyContext } from '../context/GeographyProvider';
function EntityDetails({ currentItem, isEdit,setIsEdit, setImageIds, noReceipts, fetchImages, receiptImages, setReceiptImages }) {
  const entityName = currentItem && currentItem.name;
  const entityHistoryId = currentItem && currentItem.historyId;
  const [data, setData] = useState(null);
  const { location,ipAddress} = useContext(GeographyContext);
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  const [activeTab, setActiveTab] = useState();
  const didFetchRef = useRef(false);
  const postHistoryRef = useRef(false);
  const [position, setPosition] = useState('top-right');
  const [isEntityHistorySuccess, setIsEntityHistorySuccess] = useState(false);
  const [entityHistoryState, setEntityHistoryState] = useState({
    companies: {},
    dates: []
  });

  const [hasChanges, setHasChanges] = useState(false);
  const scrollRef = useRef(null);
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const [dateDetails, setDateDetails] = useState(null);

  const [descriptions, setDescriptions] = useState([]); // Initialize with an empty description
  const [saveButtonEnabled, setSaveButtonEnabled] = useState({ global: false, price: {} });


 
  

  const addDescription = () => {
    setDescriptions([...descriptions, '']); // Add an empty description when the "Add" button is clicked
  };

  const removeDescription = (indexToRemove) => {
    setDescriptions((prevDescriptions) => prevDescriptions.filter((_, index) => index !== indexToRemove)); // Remove the description at the specified index
  };

  const handleDescriptionChange = (index, value) => {
    const updatedDescriptions = [...descriptions];
    updatedDescriptions[index] = value; // Update the description at the specified index
    setDescriptions(updatedDescriptions);
  };

  // Assuming you have an event or condition that triggers the dateDetails update
  // For example, when the activeTab changes
  const renderLabel = (label) => {
    return label.split('\n').map((line, index) => (
      <div key={index}>{line}</div>
    ));
  };

  const formatNamesForDisplay = (names) => {
    if (!names || names.length === 0) {
      return 'Unknown';
    }
    return names.map(name => name.length > 10 ? name.substring(0, 10) + '...' : name).join('\n');
  };



 
  useEffect(() => {
    if (!didFetchRef.current) {
      didFetchRef.current = true;
      setImageIds([]);
  
      let latLngQuery = "";
      if (location) {
        console.log(`Latitude: ${location?.latitude}, Longitude: ${location?.longitude}`);
        latLngQuery = `?latitude=${location?.latitude}&longitude=${location?.longitude}`;
      } else {
        latLngQuery = `?ipAddress=${ipAddress || localStorage.getItem('ipAddress')}`;
      }
  
      let endpoint = `${baseUrl}/entity-history/${entityHistoryId}`;
      endpoint = endpoint + latLngQuery;
      axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('JWT-TOKEN')}`, // Assuming tokenLoaded is your access token
        },
      })
        .then((response) => {
          const responseData = response.data;
          setImageIds(responseData.receiptIds);
  
          // Parsing dates data
          const datesParsed = (responseData.dates || []).map(dateObj => {
            const dateData = dateObj;
  
            const companiesParsed = (dateData.companies || []).map(company => ({
              name: company.name,
              id: company.id,
              originalNames: company.originalNames || [],
              prices: (company.prices || []).map(price => ({
                ...price,
                qtys: (price.qtys || []).map(qty => ({
                  ...qty,
                  weights: qty.weights || []
                }))
              }))
            }));
  
            return {
              id: dateData.id,
              date: dateData.date,
              descriptions: dateData.descriptions,
              purchaseDateId: dateData.purchaseDateId,
              companies: companiesParsed,
            };
          });
  
          const imageObjects = responseData.dates.flatMap(dateData => 
            dateData.companies.flatMap(company => 
              company.prices.map(price => ({
                dateKey: dateData.date,
                thumbnail: price.thumbnail,
                url: price.url
              }))
            )
          );
          
          // Use a Set to filter out duplicates based on the `url` property
          const uniqueImageObjects = Array.from(new Set(imageObjects.map(image => image.url)))
            .map(url => {
              return imageObjects.find(image => image.url === url);
            });
          
          setReceiptImages && setReceiptImages(uniqueImageObjects);
          
          setEntityHistoryState({
            dates: datesParsed
          });
  
          if (datesParsed.length > 0) {
            const firstDateKey = datesParsed[0].date;
            setActiveTab(firstDateKey);
          }
  
          // Combine companies and prices from all dates
          const combinedCompanies = {};
          response.data.dates.forEach(dateData => {
            dateData.companies.forEach(company => {
              if (!combinedCompanies[company.id]) {
                combinedCompanies[company.id] = {
                  name: company.name,
                  id: company.id,
                  originalNames: company.originalNames,
                  prices: []
                };
              }
              combinedCompanies[company.id].prices.push(...company.prices.map(price => ({
                ...price,
                date: dateData.date
              })));
            });
          });
  
          // Transform data for organization chart
          const datesChildren = response.data.dates.map((dateData) => ({
            label: dateData.date,
            avatar: currentItem?.imageIds && currentItem?.imageIds[currentItem?.imageIds?.length - 1],
            id: dateData.id,
            children: dateData.companies.map(company => ({
              label: company.name,
              children: [
                {
                  label: 'Original Names',
                  children: [
                    {
                      label: (
                        <DisplayList 
                          names={company.originalNames.map(originalName => originalName.name || 'Unknown')} 
                        />
                      )
                    }
                  ]
                },
                {
                  label: 'Prices',
                  children: company.prices.map((price) => ({
                    label: `${price.price}`,
                    children: (price.qtys || []).map(qty => ({
                      label: `${qty.numberOfItems}`,
                      children: (qty.weights || []).map(weight => ({
                        label: `Weight: ${weight.weight} ${weight.metrics}`,
                      }))
                    }))
                  }))
                }
              ],
            })),
          }));
  
          // Now transform the combinedCompanies into the final data structure for the organization chart
          const finalChildren = response.data.dates.map(dateData => ({
            label: dateData.date,
            
            children: dateData.companies.map(company => ({
              label: company.name,
              children: [
                {
                  label: 'Original Names',
                  children: [
                    {
                      label: (
                        <DisplayList 
                          names={company.originalNames.map(originalName => originalName.name || 'Unknown')} 
                        />
                      )
                    }
                  ]
                },
                {
                  label: 'Prices',
                  children: company.prices.map((price) => ({
                    label: `${price.price}`,
                    children: (price.qtys || []).map(qty => ({
                      label: `${qty.numberOfItems}`,
                      children: (qty.weights || []).map(weight => ({
                        label: `Weight: ${weight.weight} ${weight.metrics}`,
                      }))
                    }))
                  }))
                }
              ],
            })),
          }));
  
          const transformedData = {
            name: currentItem.name,
            label: currentItem.name,
            avatar: currentItem?.imageIds && currentItem?.imageIds[currentItem?.imageIds?.length - 1],
            children: finalChildren,
          };
  
          setData(transformedData);
        })
        .catch((error) => {
          console.error('An error occurred while fetching data:', error);
        });
    }
  }, [isEntityHistorySuccess]);
    
  const handleEditClick = async () => {
    if (!postHistoryRef.current) {
      postHistoryRef.current = true;
  
      try {
        // Construct the DTO from the current state
        const filteredDates = entityHistoryState.dates.filter(date => date.date === activeTab);

        const entityHistoryReqDto = {
          id: entityHistoryId,
          entityId: currentItem.entityId,
          customName: currentItem.customName,
          firmId: currentItem.firmId,
          nameOfEntity: currentItem.name,
          dates: filteredDates.map(date => ({
            id: date.purchaseDateId,
            date: date.date, // Assuming the date field holds the updated date
            purchaseDateId: date.purchaseDateId,
            descriptions: date.descriptions,
            companies: date.companies.map(company => ({
              name: company.name,
              id: company.id,
              originalNames: company.originalNames.map(origName => ({
                name: origName.name,
                action: origName.action,
                id: origName.id,
              })),
              prices: company.prices.map(price => ({
                price: price.price,
                id: price.id,
                qtys: price.qtys.map(q => ({
                  id: q.id,
                  numberOfItems: q.numberOfItems,
                  weights: q.weights.map(weight => ({
                    id: weight.id,
                    weight: weight.weight,
                    metrics: weight.metrics
                  }))
                }))
              }))
            })),
          }))
        };
  
        let latLngQuery = "";
        if (location) {
          console.log(`Latitude: ${location?.latitude}, Longitude: ${location?.longitude}`);
          latLngQuery = `?latitude=${location?.latitude}&longitude=${location?.longitude}`;
        } else {
          latLngQuery = `?ipAddress=${ipAddress || localStorage.getItem('ipAddress')}`;
        }
  
        let endpoint = `${baseUrl}/entity-history`;
        endpoint = endpoint + latLngQuery;
        const response = await fetch(endpoint, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('JWT-TOKEN')}`, // Assuming tokenLoaded is your access token
          },
          body: JSON.stringify(entityHistoryReqDto)
        });
  
        if (!response.ok) {
          throw new Error('Error updating entity history');
        }
  
        const updatedEntityHistory = await response.json();
       setIsEntityHistorySuccess(true);
        console.log('Entity history updated:', updatedEntityHistory);
      } catch (error) {
        console.error('Failed to update entity history:', error);
      }
    }
    postHistoryRef.current = false;
  };
  
  const handlePriceDateDetailsChange = (purchaseDateId, field, value, priceIndex = null, qtyField = null, companyIndex = null) => {
    // existing logic for handling changes...
  
    // Enable the corresponding save button and disable others
    if (field === 'price') {
      setSaveButtonEnabled(prevState => ({
        ...prevState,
        activePrice: `${companyIndex}-${priceIndex}`,
      }));
    } else {
      setSaveButtonEnabled(prevState => ({ ...prevState, global: true }));
    }
  };
  

  const handleDateDetailsChange = useCallback((dateId, field, value, index = null, subField = null, companyIndex = null, priceIndex = null) => {
    setEntityHistoryState((prevState) => {
        let updatedDates = prevState.dates.map((date) => {
            if (date.purchaseDateId === dateId) {
                let updatedDate = { ...date };

                if (field === 'purchaseDate') {
                    updatedDate.date = value instanceof Date ? value.toISOString().split('T')[0] : value;
                    setActiveTab(updatedDate.date);
                } else if (field === 'companyName') {
                    updatedDate.companies[companyIndex].name = value;
                    setSaveButtonEnabled(prevState => ({ ...prevState, global: true }));
                } else if (field === 'originalName') {
                    updatedDate.companies[companyIndex].originalNames[index].name = value;
                    setSaveButtonEnabled(prevState => ({ ...prevState, global: true }));
                } else if (field === 'price' && value >= 0) {
                    updatedDate.companies[companyIndex].prices[index].price = value;
                    setSaveButtonEnabled(prevState => ({
                        ...prevState,
                        activePrice: `${companyIndex}-${priceIndex}`
                    }));
                } else if (field === 'qty' && value >= 0) {
                    if (subField === 'numberOfItems' && value >= 0) {
                        updatedDate.companies[companyIndex].prices[priceIndex].qtys[index].numberOfItems = value;
                    } else if (subField.startsWith('weight')) {
                        const weightIndex = parseInt(subField.split('-')[1], 10);
                        updatedDate.companies[companyIndex].prices[priceIndex].qtys[index].weights[weightIndex].weight = value;
                    } else if (subField.startsWith('metrics')) {
                        const metricsIndex = parseInt(subField.split('-')[1], 10);
                        updatedDate.companies[companyIndex].prices[priceIndex].qtys[index].weights[metricsIndex].metrics = value;
                    }
                    setSaveButtonEnabled(prevState => ({
                        ...prevState,
                        activePrice: `${companyIndex}-${priceIndex}`
                    }));
                } else if (field === 'descriptions') {
                    updatedDate.descriptions = value;
                    setSaveButtonEnabled(prevState => ({ ...prevState, global: true }));
                }

                postHistoryRef.current = false;
                setHasChanges(true);
                return updatedDate;
            }
            return date;
        });

        return { ...prevState, dates: updatedDates };
    });
}, []);

  const handleAddOriginalName = (companyName, companyIndex) => {
    setEntityHistoryState((prevState) => {
      let updatedDates = prevState.dates.map((date) => {
        console.log('companyName', companyName);
        if (date.companies.some(company => company.name === companyName)) {
          let updatedDate = { ...date };
          let company = updatedDate.companies[companyIndex];
          company.originalNames.push({ name: '', id: '' });
          return updatedDate;
        }
        return date;
      });
  
      return { ...prevState, dates: updatedDates };
    });
  };
  
  const handleRemoveFields = (dateId, index, companyName, companyIndex) => {
    setEntityHistoryState((prevState) => {
      let updatedDates = prevState.dates.map((date) => {
        if (date.purchaseDateId === dateId) {
          let updatedDate = { ...date };
          if (companyName) {
            let company = updatedDate.companies[companyIndex];
            let originalName = company.originalNames[index];
            company.originalNames[index] = { ...originalName, action: 'delete' };
          }
          return updatedDate;
        }
        return date;
      });
  
      return { ...prevState, dates: updatedDates };
    });
  };
  

  const handleCompanyChange = (companyKey, newKey, newName, entityIndex = null) => {
    setEntityHistoryState(prevState => {
      let updatedCompanies = { ...prevState.companies };

      if (newKey !== companyKey) {
        updatedCompanies[newKey] = [...updatedCompanies[companyKey]];
        delete updatedCompanies[companyKey];
      } else if (newName !== undefined && entityIndex !== null) {
        updatedCompanies[companyKey] = updatedCompanies[companyKey].map((entity, index) =>
          index === entityIndex ? { ...entity, name: newName } : entity
        );
      }
      setHasChanges(true);
      return { ...prevState, companies: updatedCompanies };
    });

  };
  useEffect(() => {
    if (entityHistoryState && activeTab) {
      const newDateDetails = entityHistoryState.dates.find(date => date.date === activeTab);
      if (newDateDetails) {
        setDateDetails(newDateDetails);
      }
    }
  }, [activeTab, entityHistoryState]);

  const renderTabContent = () => {
    if (!entityHistoryState || !dateDetails) return null;
  
    return (
      <div className="container">
        <div className="row align-items-center justify-content-center">
        
            <MDBCard className="mb-2">
              <MDBCardBody>
                <MDBCardTitle>Purchase Date</MDBCardTitle>
                <MDBDatepicker
                  id={`type-date-Picker-date`}
                  format='dd, dddd, mmmm, yyyy'
                  onChange={(selectedDate) => handleDateDetailsChange(dateDetails.purchaseDateId, 'purchaseDate', selectedDate)}
                  inputLabel='Select a date'
                  key={dateDetails.date}
                  defaultValue={dateDetails.date}
                  className="mb-2"
                  inputToggle
                />
             
  
             <MDBRow className="row justify-content-center">
  <MDBCardTitle className='mb-2'>Companies</MDBCardTitle>
  {dateDetails.companies.map((company, companyIndex) => (
    <MDBCol md="6" key={`company-${company.id}`}>
      <MDBCard className="mb-2">
        <div className='position-relative d-inline-block'>
          <MDBCardBody>
            <div className='position-relative text-black rounded-5'>
              <MDBInput
                label="Company Name"
                id={`typeText-companyName-${company.id}`}
                type='text'
                value={company.name}
                onChange={(e) => handleDateDetailsChange(dateDetails.purchaseDateId, 'companyName', e.target.value, null, null, companyIndex)}
                className="mb-2"
              />
              <span style={{ position: 'absolute', top: 70, left: -10 }}>
                <MDBBadge color='none' tag='a' light pill className='position-absolute start-0 translate-middle p-5'>
                  <MDBBtn tag='a' color='none' floating onClick={() => handleAddOriginalName(company.name, companyIndex)}>
                    <MDBIcon fas icon="plus-circle" />
                  </MDBBtn>
                </MDBBadge>
              </span>
            </div>
            {[...new Set(company.originalNames?.filter(originalName => (originalName.name !== undefined && originalName.action !== 'delete')) || [])].map((originalName, originalNameIndex) => (
              <div key={originalNameIndex} className='position-relative text-black rounded-5'>
                <MDBBadge color='none' light pill className='position-absolute top-0 start-100 translate-middle p-2'>
                  <MDBBtn className='ms-2' tag='a' color='none' floating onClick={() => handleRemoveFields(dateDetails.purchaseDateId, originalNameIndex, company.name, companyIndex)} style={{ color: '#dd4b39' }}>
                    <MDBIcon fas icon="trash-alt" />
                  </MDBBtn>
                </MDBBadge>
                <MDBInput
                  label={company.originalNames.length > 1 ? `Original Name-${originalNameIndex}` : 'Original Name'}
                  id={`typeText-originalName-${originalNameIndex}`}
                  type='text'
                  value={originalName.name}
                  onChange={(e) => handleDateDetailsChange(dateDetails.purchaseDateId, 'originalName', e.target.value, originalNameIndex, null, companyIndex)}
                  key={`originalName-${originalNameIndex}`}
                  className="mb-2"
                />
              </div>
            ))}
            
            <MDBCardHeader>Price(s)</MDBCardHeader>
            {company.prices.map((price, priceIndex) => (
              <div key={`price-${company.id}-${price.id}`} className='mb-2'>
                <MDBCard className='text-black'>
                  <MDBCardBody>
                    <MDBInput
                      label={`Price`}
                      id={`typeText-price-${companyIndex}-${priceIndex}`}
                      type="number"
                      value={price.price}
                      onChange={(e) => handleDateDetailsChange(dateDetails.purchaseDateId, 'price', e.target.value, priceIndex, null, companyIndex)}
                      className="mb-2"
                    />
                    
                    
                    {price.qtys.map((qty, qtyIndex) => (
                      <div key={`qty-${company.id}-${qty.id}`} className="mb-2">
                        <MDBCard className='text-black'>
                          <MDBCardHeader>Quantity</MDBCardHeader>
                          <MDBCardBody>
                            <MDBInput
                              label={`Number of Items`}
                              id={`typeText-numberOfItems-${companyIndex}-${priceIndex}-${qtyIndex}`}
                              type="number"
                              value={qty.numberOfItems}
                              onChange={(e) => handleDateDetailsChange(dateDetails.purchaseDateId, 'qty', e.target.value, qtyIndex, 'numberOfItems', companyIndex, priceIndex)}
                              className="mb-2"
                            />
                            {qty.weights.map((weight, weightIndex) => (
                              <div key={`weight-${company.id}-${qty.id}-${weight.id}`} className="mb-2">
                                <MDBInput
                                  label={`Weight ${weightIndex + 1}`}
                                  id={`typeText-weight-${companyIndex}-${priceIndex}-${qtyIndex}-${weightIndex}`}
                                  type="number"
                                  value={weight.weight}
                                  onChange={(e) => handleDateDetailsChange(dateDetails.purchaseDateId, 'qty', e.target.value, qtyIndex, `weight-${weightIndex}`, companyIndex, priceIndex)}
                                  className="mb-2"
                                />
                                <MDBInput
                                  label={`Metrics ${weightIndex + 1}`}
                                  id={`typeText-metrics-${companyIndex}-${priceIndex}-${qtyIndex}-${weightIndex}`}
                                  type='text'
                                  value={weight.metrics}
                                  onChange={(e) => handleDateDetailsChange(dateDetails.purchaseDateId, 'qty', e.target.value, qtyIndex, `metrics-${weightIndex}`, companyIndex, priceIndex)}
                                  className="mb-2"
                                />
                              </div>
                            ))}
                          </MDBCardBody>

                          
                        </MDBCard>
                      </div>
                    ))}
                  </MDBCardBody>
                  <MDBCardFooter>   <MDBBtn
                    color="success"
                    className="mt-2"
                    disabled={saveButtonEnabled.activePrice !== `${companyIndex}-${priceIndex}`}
                    onClick={() =>  handleEditClick()}
                >
                    Save
                </MDBBtn></MDBCardFooter> 
                </MDBCard>
              </div>
            ))}
          </MDBCardBody>
        </div>
      </MDBCard>
    </MDBCol>
  ))}
</MDBRow>


            <MDBCard className="mb-2">
              <MDBCardBody>
                <MDBCardTitle>Descriptions</MDBCardTitle>
                <MDBChipsInput
                  label='Descriptions'
                  editable
                  initialValues={dateDetails.descriptions.map((description) => ({ tag: description }))}
                  onAdd={(value) => {
                    handleDateDetailsChange(dateDetails.purchaseDateId, 'descriptions', [...dateDetails.descriptions, value], null, 'descriptions');
                  }}
                  onDelete={(value, index) => {
                    const updatedDescriptions = [...dateDetails.descriptions];
                    updatedDescriptions.splice(index, 1);
                    handleDateDetailsChange(dateDetails.purchaseDateId, 'descriptions', updatedDescriptions, index, 'descriptions');
                  }}
                />
              </MDBCardBody>
            </MDBCard>
            </MDBCardBody>
            </MDBCard>
          
        </div>
      </div>
    );
  };
  



  return (
    (isEdit && data) ? (
      <>
        <MDBAlert open={isEntityHistorySuccess} color='primary' autohide position={position} delay={2000} appendToBody>
          Entity has been updated! <MDBBtn color='warning' className='m-1' onClick={() => setIsEntityHistorySuccess(false)}>x</MDBBtn>
        </MDBAlert>
  
        <MDBTabs fill className='mb-3'>
          {entityHistoryState.dates.map((date, index) => (
            <MDBTabsItem key={index}>
              <MDBTabsLink onClick={() => handleTabClick(date.date)} active={activeTab === date.date}>
                {date.date}
              </MDBTabsLink>
            </MDBTabsItem>
          ))}
        </MDBTabs>
  
        <MDBTabsContent>
          <MDBInfiniteScroll
            infiniteDirection='x'
            infiniteScrollRef={scrollRef}
            className='py-3 text-center'
            style={{ maxWidth: '100%', overflowX: 'scroll', whiteSpace: 'nowrap' }}
          >
            {renderTabContent()}
          </MDBInfiniteScroll>
        </MDBTabsContent>
  
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <MDBBtn color="success" className="mt-4 mb-md-0 me-2 responsive-button" disabled={!hasChanges} onClick={() => {
            handleEditClick();
          }}>
            Save
          </MDBBtn>
  
          <MDBBtn color="warning" className="mt-4 mb-md-0 me-2 responsive-button"
            onClick={() => {
              setIsEdit(false);
            }}
          >
            Back to view
          </MDBBtn>
        </div>
      </>
    ) : (
      data ? (
        <>
         <MDBCarousel showIndicators showControls fade dark className='mb-3'>
    {(currentItem?.descriptions || dateDetails?.descriptions || []).map((description, index) => (
        <MDBCarouselItem key={index} itemId={index + 1} src={descImage} alt={description}>
            <h5>{description}</h5>
        </MDBCarouselItem>
    ))}
</MDBCarousel>

  
          <MDBAlert open={noReceipts} className='w-50' color='danger' delay={2000}>
            <i className="fas fa-times-circle me-3"></i>Receipts found
          </MDBAlert>
          <MDBOrganizationChart data={data} className="text-center align-items-center" />
        </>
      ) : (
        <div className='d-flex justify-content-center text-center'>
          <MDBSpinner color='warning'>
            <span className='visually-hidden'>Loading...</span>
          </MDBSpinner>
        </div>
      )
    )
  );
  
}

EntityDetails.propTypes = {
  currentItem: PropTypes.object,
  isEdit: PropTypes.bool,
  noReceipts: PropTypes.bool,
  setIsEdit: PropTypes.func,
  setImageIds: PropTypes.func,
  fetchImages: PropTypes.func,
  setReceiptImages: PropTypes.func,
  receiptImages: PropTypes.array,
};


export default EntityDetails;
